import axios from 'axios';

let configuredAxios = null;

/**
 * Configure the global axios instance used by the generated client.
 * Frontend should call this with its interceptors-enabled instance.
 */
export function configureApiClient(instance) {
  configuredAxios = instance;
}

export function getAxios() {
  if (configuredAxios) return configuredAxios;
  return axios;
}

export { axios };
export default axios;
